"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports["default"] = function (condition, message) {
	if (!condition) {
		throw new Error(message);
	}
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/assert.js
// module id = sa0k
// module chunks = 15